module.exports = __webpack_public_path__ + "img/icon-code1.1f1e1548.svg";